import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      // Simulate subscription API call
      setIsSubscribed(true);
      setEmail('');
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Get Estimate', path: '/estimation' },
    { name: 'Booking', path: '/booking' },
    { name: 'Contact', path: '/contact' }
  ];

  const services = [
    'Standard Carpet Cleaning',
    'Premium Deep Cleaning',
    'Stain Removal',
    'Commercial Cleaning',
    'Emergency Services'
  ];

  const contactInfo = [
    { icon: '📞', label: 'Phone', value: '+61 1300 989 330', link: 'tel:+611300989330' },
    { icon: '✉️', label: 'Email', value: 'greenrockycarpet@gmail.com', link: 'mailto:greenrockycarpet@gmail.com' },
    { icon: '📍', label: 'Address', value: '2/10 Thompson St, Park Avenue QLD 4701, Australia', link: 'https://maps.google.com' },
    { icon: '🕒', label: 'Emergency', value: '24/7 Available', link: 'tel:+611300989330' }
  ];

  const businessHours = [
    { day: 'Saturday - Friday', hours: '24 Hours' },
    { day: 'Emergency Service', hours: '24/7 Available' }
  ];

  const socialLinks = [
    { name: 'Facebook', icon: '📘', url: 'https://www.facebook.com/profile.php?id=100065186183088&mibextid=ZbWKwL' },
    { name: 'Instagram', icon: '📷', url: 'https://www.instagram.com/greenmelbournecarpetcleaning/' },
    { name: 'LinkedIn', icon: '💼', url: 'https://linkedin.com' },
    { name: 'Yelp', icon: '⭐', url: 'https://yelp.com' }
  ];

  const certifications = [
    { name: 'IICRC Certified', icon: '🏆' },
    { name: 'Green Clean', icon: '🌿' },
    { name: 'EPA Safer Choice', icon: '🛡️' },
    { name: 'BBB A+ Rating', icon: '⭐' }
  ];

  const paymentMethods = [
    '💳 Visa', '💳 MasterCard', '💳 Amex', '💳 Discover', '💰 Cash', '📱 Apple Pay', '📱 Google Pay'
  ];

  return (
    <footer className="footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-section">
              <div className="footer-logo">
                <div className="logo-icon">🧹</div>
                <div className="logo-text">
                  <h3>GreenRocky Carpet</h3>
                  <span>Professional Carpet Cleaning</span>
                </div>
              </div>
              <p className="company-description">
                Providing eco-friendly carpet cleaning services with over 6 years of experience. 
                We're committed to delivering exceptional results while protecting our environment.
              </p>
              
              {/* Trust Badges */}
              <div className="footer-trust-badges">
                {certifications.map((cert, index) => (
                  <div key={index} className="footer-trust-badge">
                    <span className="footer-badge-icon">{cert.icon}</span>
                    <span className="footer-badge-text">{cert.name}</span>
                  </div>
                ))}
              </div>

              {/* Social Links */}
              <div className="social-links">
                <h4>Follow Us</h4>
                <div className="social-icons">
                  {socialLinks.map((social, index) => (
                    <a 
                      key={index}
                      href={social.url}
                      className="social-link"
                      aria-label={social.name}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="social-icon">{social.icon}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h3 className="footer-section-title">Quick Links</h3>
              <ul className="footer-links">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path} className="footer-link">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>

              <div className="services-preview">
                <h4>Our Services</h4>
                <div className="service-tags">
                  {services.map((service, index) => (
                    <span key={index} className="service-tag">{service}</span>
                  ))}
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div className="footer-section">
              <h3 className="footer-section-title">Contact Info</h3>
              <div className="contact-list">
                {contactInfo.map((contact, index) => (
                  <a 
                    key={index}
                    href={contact.link}
                    className="contact-item"
                  >
                    <span className="contact-icon">{contact.icon}</span>
                    <div className="contact-details">
                      <span className="contact-label">{contact.label}</span>
                      <span className="contact-value">{contact.value}</span>
                    </div>
                  </a>
                ))}
              </div>

              {/* Business Hours */}
              <div className="business-hours">
                <h4>Business Hours</h4>
                <div className="hours-list">
                  {businessHours.map((schedule, index) => (
                    <div key={index} className="hour-item">
                      <span className="day">{schedule.day}</span>
                      <span className="hours">{schedule.hours}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Newsletter & CTA */}
            <div className="footer-section">
              <h3 className="footer-section-title">Stay Updated</h3>
              <div className="newsletter">
                <p>Subscribe to our newsletter for cleaning tips and exclusive offers!</p>
                
                {isSubscribed ? (
                  <div className="success-message">
                    <span className="success-icon">✅</span>
                    Thank you for subscribing!
                  </div>
                ) : (
                  <form onSubmit={handleSubscribe} className="newsletter-form">
                    <div className="input-group">
                      <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="newsletter-input"
                      />
                      <button type="submit" className="subscribe-btn">
                        Subscribe
                      </button>
                    </div>
                  </form>
                )}

                <div className="newsletter-benefits">
                  <div className="benefit-item">
                    <span className="benefit-icon">🎁</span>
                    Exclusive Discounts
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">💡</span>
                    Cleaning Tips
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">⭐</span>
                    Special Offers
                  </div>
                </div>
              </div>

              {/* Emergency CTA */}
              <div className="footer-emergency-cta">
                <div className="footer-emergency-icon">🚨</div>
                <div className="footer-emergency-content">
                  <h4>Emergency Service</h4>
                  <p>24/7 available</p>
                  <a href="tel:+611300989330" className="footer-emergency-btn">
                    Call Now: +61 1300 989 330
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Methods */}
      <div className="payment-section">
        <div className="container">
          <div className="payment-content">
            <span className="payment-label">We Accept:</span>
            <div className="payment-methods">
              {paymentMethods.map((method, index) => (
                <span key={index} className="payment-method">{method}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2025 greenrockycarpet.com.au. All rights reserved.</p>
            </div>
            
            <div className="legal-links">
              <Link to="/privacy" className="legal-link">Privacy Policy</Link>
              <Link to="/terms" className="legal-link">Terms of Service</Link>
              <Link to="/sitemap" className="legal-link">Sitemap</Link>
            </div>

            <div className="stats">
              <span className="stat-item">🏆 6+ Years Experience</span>
              <span className="stat-item">⭐ 4.9/5 Rating</span>
              <span className="stat-item">👥 6K+ Customers</span>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button 
        className="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Back to top"
      >
        ↑
      </button>
    </footer>
  );
};

export default Footer;